module.exports = __webpack_public_path__ + "images/RBL_Umeed-2020e595e31fa6e827b44f11e7b431441c98.jpg";